import { createMarkup } from '@/shared/lib/utils/common/createMarkup'

import { PromotionSummary } from '../PromotionSummary/PromotionSummary'

import styles from './ArticleTerms.module.scss'

export type ActionConditionProps = {
	description: string
	ACTIVE_TO: string
}

export const ArticleTerms = ({ description, ACTIVE_TO }: ActionConditionProps): JSX.Element => (
	<article className={styles.promotionTerms}>
		{ACTIVE_TO && <PromotionSummary ACTIVE_TO={ACTIVE_TO} />}
		<div className={styles.description} dangerouslySetInnerHTML={createMarkup(description)} />
	</article>
)
